import {AxiosProgressEvent} from 'axios';
import {PostRefundUploadFile} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundPostUploadFile} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makePostRefundUploadFile = (
	onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
): PostRefundUploadFile =>
	new RemoteRefundPostUploadFile(
		makeBFFApiUrl(RefundFlowEndPoints.attachment),
		makeAuthorizeHttpClientDecorator(),
		onUploadProgress,
	);
